// @flow

// eslint-disable-next-line import/prefer-default-export
export const isObject = (o: *) => typeof o === 'object' && o !== null && !Array.isArray(o);
